export const storeLinkClick = store => ({
  type: 'STORE_LINK_CLICK',
  store,
});

export const adsViewUpdate = () => ({
  type: 'ADS_VIEW_UPDATE',
  view: 'store:mounted',
});

export default {
  storeLinkClick,
};
